import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "style", "id", "name", "checked", "value", "onChange", "theme", "icon"];
import React from 'react';
import withTheme from '../theme/withTheme';
import { Wrapper, Input, Check, Text } from './styles';
import CheckIcon from '../Icons/Check';
var _ref = /*#__PURE__*/React.createElement(CheckIcon, {
  width: 10,
  height: 8
});
var DefaultIcon = function DefaultIcon() {
  return _ref;
};
var RadioButton = function RadioButton(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style,
    id = _ref2.id,
    name = _ref2.name,
    checked = _ref2.checked,
    value = _ref2.value,
    onChange = _ref2.onChange,
    theme = _ref2.theme,
    Icon = _ref2.icon,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Input, _extends({
    type: "radio",
    id: id,
    name: name,
    checked: checked,
    value: value,
    onChange: onChange,
    theme: theme
  }, rest)), /*#__PURE__*/React.createElement(Check, {
    checked: checked,
    theme: theme,
    onClick: onChange
  }, /*#__PURE__*/React.createElement(Icon, null)), children && /*#__PURE__*/React.createElement(Text, {
    htmlFor: id,
    theme: theme
  }, children));
};
RadioButton.defaultProps = {
  checked: false,
  onChange: function onChange() {},
  icon: DefaultIcon
};
export default withTheme(RadioButton);